import React, { useContext, useEffect } from "react";
import "../../../assests/css/students/BlogCard.css";
import { useNavigate } from "react-router-dom";
import { AppContext } from "../../../context/Appcontext";

const BlogCard = ({blog}) => {
  const navigate = useNavigate();
  const {baseUrlForFiles} = useContext(AppContext);

  useEffect(()=>{
    console.log("************blog card ki screen ", blog)
  },[])

  return (
    <div className="tmc-card">
      <img
        // src="https://images.unsplash.com/photo-1522202176988-66273c2fd55f"
        src= {`${baseUrlForFiles}/${blog?.image}`}
        alt="Time Management"
        className="tmc-img"
      />

      <h4 className="tmc-title">
        {/* Effective Time Management for Students */}
        {blog?.title}
      </h4>

      {/* <span className="tmc-date">February 20, 2024</span> */}
      <span className="tmc-date">{blog?.created_at}</span>

      {/* <button
        className="tmc-btn"
        onClick={() => navigate("/blogsdetail")}
      >
        Read More
      </button> */}
    </div>
  );
};

export default BlogCard;
